/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CombinedPackage } from '../models/CombinedPackage';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CombinedPackageService {
    /**
     * Create a new combined package (admin only)
     * @param requestBody
     * @returns CombinedPackage Combined package created successfully
     * @throws ApiError
     */
    public static postPackageCombine(
        requestBody: any,
    ): CancelablePromise<CombinedPackage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/package/combine',
            body: requestBody,
            errors: {
                403: `Access denied - Admin only`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get all combined packages
     * @param isShipped Filter by shipped status
     * @param state Filter combined packages by state
     * @param search Search combined packages by description or user email
     * @param skip Number of records to skip for pagination
     * @param take Number of records to return for pagination
     * @param userId Filter by user ID (admin only)
     * @returns any Paginated list of combined packages
     * @throws ApiError
     */
    public static getPackageCombine(
        isShipped?: boolean,
        state?: 'REQUESTED' | 'APPROVED' | 'DRAFT' | 'DONE',
        search?: string,
        skip?: number,
        take?: number,
        userId?: string,
    ): CancelablePromise<{
        data?: Array<CombinedPackage>;
        pagination?: {
            total?: number;
            page?: number;
            limit?: number;
            pages?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/package/combine',
            query: {
                'isShipped': isShipped,
                'state': state,
                'search': search,
                'skip': skip,
                'take': take,
                'userId': userId,
            },
            errors: {
                403: `Access denied`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get combined package by ID
     * @param id
     * @returns CombinedPackage Combined package details
     * @throws ApiError
     */
    public static getPackageCombine1(
        id: number,
    ): CancelablePromise<CombinedPackage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/package/combine/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Package not found or access denied`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update combined package by ID
     * @param id
     * @param requestBody
     * @returns CombinedPackage Combined package updated successfully
     * @throws ApiError
     */
    public static putPackageCombine(
        id: number,
        requestBody: {
            custom_value?: number;
            description?: string;
            weight?: number;
            length?: number;
            width?: number;
            height?: number;
            quantity?: number;
            shipping_cost?: number;
            /**
             * Base64 encoded image data
             */
            image?: string;
            state?: 'REQUESTED' | 'APPROVED' | 'DRAFT' | 'DONE';
        },
    ): CancelablePromise<CombinedPackage> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/package/combine/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Package not found or access denied`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete combined package by ID
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deletePackageCombine(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/package/combine/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Package not found or access denied`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request to combine packages (user action)
     * Allows users to request combining multiple packages into one combined package
     * @param requestBody
     * @returns CombinedPackage Combined package request created successfully
     * @throws ApiError
     */
    public static postPackageCombineRequest(
        requestBody: {
            /**
             * Array of package IDs to combine
             */
            packageIds: Array<number>;
        },
    ): CancelablePromise<CombinedPackage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/package/combine/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Package IDs are required or packages not found/access denied`,
                500: `Internal Server Error`,
            },
        });
    }
}
